import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../Utilities/app-config.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
    private apiService: ApiService,
    private appConfig: AppConfig
  ) { }

  getSystemWhatIsNewFeatureList(isForAll = false): Observable<any> {
    return this.apiService.get(this.appConfig.GetUrl("systemWhatIsNewFeatureList") + (isForAll ? '?isForAll=true' : ''));
  }

  MarkAsLaterFeaturePage(pageId) {
    const postData = {
      IsRemindMeLater: true,
      IsCompleted: false
    };
    return this.apiService.post(this.appConfig.GetUrl("MarkFeaturePage").replace("[PAGEID]", pageId), postData);
  }

  MarkCompletedFeaturePage(pageId) {
    const postData = {
      IsRemindMeLater: false,
      IsCompleted: true
    };
    return this.apiService.post(this.appConfig.GetUrl("MarkFeaturePage").replace("[PAGEID]", pageId), postData);
  }
}
